import { Button } from '../form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { Loading } from '@/components/loading/Loading';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { useSelection } from '@/services/selection/useSelectionProvider';
import { useInvalidateList } from '@/utils/explorer';
import { useDeleteItems, useInvalidateChildren } from '@/utils/folder';

import { FunctionComponent, Suspense } from 'react';
import { useParams } from 'react-router';
import { toast } from 'sonner';

const DeleteFilesConfirmationModal: FunctionComponent<ModalProps> = props => {
  const DeleteFiles = () => {
    const { itemId } = useParams<{ directoryId: string; itemId: string }>();

    if (!itemId) throw new Error('Missing folder id');

    const selected = useSelection(state => state.selected);

    const deleteDriveItems = useDeleteItems();
    const invalidateChildren = useInvalidateChildren(itemId);
    const invalidateList = useInvalidateList();

    const onDelete = async () => {
      try {
        await deleteDriveItems.mutateAsync(Array.from(selected));
        await invalidateList();
        await invalidateChildren();

        props.close();

        toast('Deleted files');
      } catch (error) {
        console.error('Error occurred while deleting files:', error);
      }
    };

    return (
      <Card className="w-full p-8 space-y-2">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-bold">Delete Selected Files</h1>
        </Modal.Controls>

        <div className="space-y-6">
          <p>Are you sure you want to delete the selected items?</p>

          <div className="flex gap-2 justify-between">
            <Button onClick={props.close}>Cancel</Button>
            <Button
              type="button"
              variant={ButtonVariant.Destructive}
              loading={deleteDriveItems.isLoading}
              onClick={onDelete}
            >
              Delete
            </Button>
          </div>
        </div>
      </Card>
    );
  };

  return (
    <Modal className="md:max-w-xl" {...props}>
      <Suspense fallback={<Loading />}>
        <DeleteFiles />
      </Suspense>
    </Modal>
  );
};

export default DeleteFilesConfirmationModal;
